import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "topbar" }
const _hoisted_2 = ["aria-label", "aria-expanded"]
const _hoisted_3 = { class: "header" }
const _hoisted_4 = {
  class: "title",
  style: {"color":"white"}
}
const _hoisted_5 = { class: "background" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = ["aria-labelledby"]
const _hoisted_10 = ["id"]
const _hoisted_11 = ["href"]

import { useRoute } from 'vue-router'
import { computed, onErrorCaptured, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import LanguageSwitcher from './components/LanguageSwitcher.vue'
import AnnouncementBell from './components/AnnouncementBell.vue'
import { Toaster, toast } from 'vue-sonner'
import 'vue-sonner/style.css'
import PanelLayout from './components/Layout/PanelLayout.vue'
import StorageSettings from './components/StorageSettings.vue'
import { DesktopStorageError } from './services/storage/desktopStorage'
import { StorageSyncPausedError } from './services/storage/storage'
import homePageData from './configs/homePage.json'

interface NavigationCard {
  id: string;
  href: string;
  title: string;
  titleKey?: string;
}

interface NavigationCategory {
  id: string;
  title: string;
  titleKey?: string;
  color: string;
  background: string;
  cards: NavigationCard[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const navigationCategories: NavigationCategory[] = homePageData.categories

const route = useRoute()
onErrorCaptured((error) => {
  if (error instanceof DesktopStorageError || error instanceof StorageSyncPausedError) {
    toast.error(error.message, { id: 'desktop-storage-error' })
    return false
  }
})
const { t, te } = useI18n({ useScope: 'global' })
const displayText = (value: string, key?: string) => key && te(key) ? t(key) : value
const isExternalLink = (href: string) => /^(?:https?:)?\/\//i.test(href)
const pageTitle = computed(() => typeof route.meta.titleKey === 'string'
  ? t(route.meta.titleKey)
  : String(route.meta.title || t('app.defaultTitle')))

watch(pageTitle, (title) => { document.title = title }, { immediate: true })

const isLocal = process.env.NODE_ENV === "development"

const open = ref(false)
function OpenSidebar() {
  open.value = true;
}

function CloseSidebar() {
  open.value = false;
}

watch(() => route.fullPath, () => {
  open.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Toaster), { position: "top-center" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        style: {"width":"54px","height":"54px","background-color":"#6a5acdAA","border-radius":"15%"},
        id: "menuBtn",
        "aria-label": _unref(t)('app.openNavigation'),
        "aria-expanded": open.value,
        "aria-controls": "sidebar",
        onClick: OpenSidebar
      }, "☰", 8, _hoisted_2),
      _createVNode(PanelLayout, { class: "title-panel" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("img", {
              src: _imports_0,
              style: {"height":"36px","width":"36px","margin":"0px,20px"}
            }, null, -1)),
            _createElementVNode("h2", _hoisted_4, _toDisplayString(pageTitle.value), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(AnnouncementBell),
      _createVNode(StorageSettings),
      _createVNode(LanguageSwitcher)
    ]),
    _createElementVNode("main", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_view)
      ])
    ]),
    _createElementVNode("div", {
      id: "overlay",
      class: _normalizeClass(["overlay", { show: open.value }]),
      onClick: CloseSidebar
    }, null, 2),
    _createElementVNode("div", {
      id: "sidebar",
      class: _normalizeClass(["sidebar", { open: open.value }])
    }, [
      _createElementVNode("h2", null, _toDisplayString(_unref(t)('app.navigation')), 1),
      isLocal
        ? (_openBlock(), _createElementBlock("nav", _hoisted_7, [
            _createElementVNode("h4", null, _toDisplayString(_unref(t)('app.testTools')), 1),
            _createVNode(_component_router_link, { to: "/about" }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("About", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/debugpanel" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("debugpanle", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/OverSeaUpload" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("海外上传工具", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("nav", {
        class: "sidebar-navigation",
        "aria-label": _unref(t)('app.navigation')
      }, [
        _createVNode(_component_router_link, {
          to: "/",
          onClick: CloseSidebar
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('app.home')), 1)
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigationCategories), (category) => {
          return (_openBlock(), _createElementBlock("section", {
            key: category.id,
            class: "sidebar-category",
            "aria-labelledby": `sidebar-category-${category.id}`,
            style: _normalizeStyle({ '--category-color': category.color, '--category-background': category.background })
          }, [
            _createElementVNode("h3", {
              id: `sidebar-category-${category.id}`,
              class: "sidebar-category-title"
            }, _toDisplayString(displayText(category.title, category.titleKey)), 9, _hoisted_10),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.cards, (card) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: card.id
              }, [
                (isExternalLink(card.href))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: card.href,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      onClick: CloseSidebar
                    }, _toDisplayString(displayText(card.title, card.titleKey)), 9, _hoisted_11))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: card.href,
                      onClick: CloseSidebar
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(displayText(card.title, card.titleKey)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
              ], 64))
            }), 128))
          ], 12, _hoisted_9))
        }), 128))
      ], 8, _hoisted_8)
    ], 2)
  ], 64))
}
}

})